import { AppForm } from '../../../../../common/forms/app.form';
import { FormControl, Validators } from '@angular/forms';
import { Injectable } from '@angular/core';
import { AttachmentAttachmentRead, CivicBudgetProjectAppEntityCivicBudgetProjectWrite } from '../../../../../openapi';

@Injectable()
export class CivicBudgetSubmitProjectForm extends AppForm {

  public uploading = false;

  constructor() {
    super({
      projectName: new FormControl(null, [Validators.required, Validators.maxLength(255)]),
      description: new FormControl(null, [Validators.required, Validators.maxLength(5000)]),
      justification: new FormControl(null, [Validators.required, Validators.maxLength(5000)]),
      submitter: new FormControl(null, [Validators.required, Validators.maxLength(255)]),
      budget: new FormControl(null, [Validators.required, Validators.maxLength(255)]),
      attachments: new FormControl([], { nonNullable: true, validators: [Validators.maxLength(255)] })
    });
  }

  public toWriteModel(): CivicBudgetProjectAppEntityCivicBudgetProjectWrite {
    return {
      name: this.value.projectName,
      description: this.value.description,
      submitter: this.value.submitter,
      budget: `${this.value.budget}`,
      attachments: this.value.attachments?.map((attachment: AttachmentAttachmentRead) => attachment.id)
    };
  }
}
